import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ContentService } from '@common/services/content.service';
import { GoogleAnalyticsService } from '@common/services/google-analytics.service';
import { CommunityService } from '@common/services/community.service';
import {
    InfoComponentBase,
    InfoItem,
} from '@common/components/info/info.component.base';
import { ContentHelperService } from '../../services/contenthelper.service';
import { JapanAddressService } from '@lang/jp/services/japan-address.service';
import { PhaseJpService } from '@lang/jp/services/phasejp.service';
import { EnjpCommunityService } from '../../services/community.service';

export const infoItems: InfoItem[] = [
    new InfoItem('what-is-this-program'),
    new InfoItem('how-does-it-work', false, 6),
    new InfoItem('how-much-can-i-save'),
    new InfoItem('switching-is-easy'),
    new InfoItem('increasing-renewable-energy'),
    new InfoItem('renewables-from-fukushima', true, 0, null, ['kyoto']),
    new InfoItem('what-is-switching'),
    new InfoItem('about-webinars'),
    new InfoItem(
        'article-list',
        true,
        0,
        null,
        JapanAddressService.TmgCommunities,
    ),
    new InfoItem(
        'relationship-with-tmg',
        true,
        0,
        null,
        JapanAddressService.TmgCommunities,
    ),
    new InfoItem('relationship-with-suita', true, 0, null, ['suita']),
    new InfoItem('relationship-with-kyoto', true, 0, null, ['kyoto']),
    new InfoItem('relationship-with-fukuoka', true, 0, null, ['fukuoka-city']),
    new InfoItem('relationship-with-nagano', true, 0, null, ['nagano-city']),
    new InfoItem('relationship-with-osaka', true, 0, null, ['osaka']),
    new InfoItem('relationship-with-gifu', true, 0, null, ['gifu']),
];
@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    standalone: false
})
export class InfoComponent
    extends InfoComponentBase
    implements OnInit, OnDestroy
{
    routeParams: Subscription;

    constructor(
        public contentHelperService: ContentHelperService,
        public phaseService: PhaseJpService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected content: ContentService,
        protected analytics: GoogleAnalyticsService,
        protected communityService: CommunityService,
        protected enjpCommunityService: EnjpCommunityService,
    ) {
        super(router, route, content, analytics, communityService, infoItems);
    }

    get communityCode() {
        return this.communityService.communityCode;
    }

    get registrationEnabled$(): Observable<boolean> {
        return this.enjpCommunityService.isCommunityRegistrationEnabled$;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
